import { render } from "./PopupWhats.vue?vue&type=template&id=b255a82e&scoped=true"
import script from "./PopupWhats.vue?vue&type=script&async=true&lang=js"
export * from "./PopupWhats.vue?vue&type=script&async=true&lang=js"

import "./PopupWhats.vue?vue&type=style&index=0&id=b255a82e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b255a82e"]])

export default __exports__